import { jsPDF } from "jspdf";
import "svg2pdf.js";
import autoTable from "jspdf-autotable";
import React from "react";
import logoGoogleMarine from "../../assets/icons/logo-googlemarine.svg";

export async function generatePdfReport({
  reportTitle,
  fileNamePrefix,
  subtitle,
  headers,
  rows,
  custoColIndex = 3,
  enabledColumns,
  footerLines = [],
}: {
  reportTitle: string;
  fileNamePrefix: string;
  subtitle: string;
  headers: string[];
  rows: (string | number | React.ReactNode)[][];
  custoColIndex?: number;
  enabledColumns?: number[];
  footerLines?: string[];
}) {
  const columnIndexes =
    enabledColumns && enabledColumns.length > 0
      ? enabledColumns
      : headers.map((_, i) => i);

  const filteredHeaders = columnIndexes.map((i) => headers[i]);
  const filteredRows = rows.map((row) =>
    columnIndexes.map((i) =>
      typeof row[i] === "string" || typeof row[i] === "number"
        ? String(row[i])
        : ""
    )
  );
  const doc = new jsPDF();

  const response = await fetch(logoGoogleMarine);
  const logoSvg = await response.text();

  await doc.addSvgAsImage(logoSvg, 16, 12, 17, 7.5);

  const companyInfo = [
    "**LECSOR TECHNOLOGY LTDA**",
    "**https://lecsor.com.br/**",
    "",
    "CNPJ: 28.366.167/0001-90",
    "",
    "R DELEGADO WALDIR GUILHERME, 32",
    "ILHA DA CONCEICAO",
    "Niteroi - RJ - CEP: 24050-170",
    "Telefone: (21) 3614-0926",
  ];

  doc.setFontSize(9);
  let y = 10;
  let enderecoY = 0;
  companyInfo.forEach((line) => {
    const isBold = line.startsWith("**") && line.endsWith("**");
    const cleanLine = line.replace(/\*\*/g, "");
    doc.setFont("helvetica", isBold ? "bold" : "normal");
    doc.text(cleanLine, 200, y, { align: "right" });
    if (cleanLine.startsWith("R DELEGADO")) enderecoY = y;
    y += 4;
  });

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text(reportTitle, 14, enderecoY + 5);

  const now = new Date();
  const formattedDate = now.toLocaleDateString("pt-BR").replace(/[/]/g, "/");
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(
    `Data de Geração do Relatório: ${formattedDate}`,
    14,
    enderecoY + 10 // Posição ajustada
  );

  // Adicionando o Horário de Geração do Relatório
  const formattedTime = now.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  doc.text(
    `Horário de Geração do Relatório: ${formattedTime}`,
    14,
    enderecoY + 15 // Posição ajustada
  );

  // Ajustando o subtítulo para ficar próximo do título
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.text(subtitle, 14, enderecoY + 40); // Posição ajustada

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  let yFooter = y + 30; // Ajuste no yFooter para garantir que não há grandes espaçamentos
  footerLines.forEach((line) => {
    doc.text(line, 14, yFooter);
    yFooter += 5;
  });

  doc.setFontSize(7);
  autoTable(doc, {
    startY: yFooter + 5,
    head: [filteredHeaders],
    body: filteredRows,
    styles: {
      fontSize: 9,
      halign: "center",
      valign: "middle",
      lineColor: [0, 0, 0],
      lineWidth: 0.25,
      cellPadding: 2,
    },
    headStyles: {
      fillColor: [18, 66, 128],
      textColor: 255,
      fontStyle: "normal",
    },
    bodyStyles: {
      lineColor: [0, 0, 0],
    },
    margin: { left: 13, right: 10 },
    tableWidth: "auto",
  });

  const formattedDateTime = now
    .toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(/[\/:]/g, "-")
    .replace(",", "");

  doc.save(`${fileNamePrefix}-${formattedDateTime}.pdf`);
}
